const TOKEN_KEY = 'GUIDERUSER.token'
const ACCOUNT_KEY = 'GUIDERUSER.accountId'
const SWITCH_ACCOUNT_KEY = 'GUIDERUSER.switchAccountId'
const USERGROUPID_KEY = 'GUIDERUSER.userGroupId'

// token
export const setToken = (token) => {
  return sessionStorage.setItem(TOKEN_KEY, token)
}
export const getToken = () => {
  return sessionStorage.getItem(TOKEN_KEY)
}

// accountId
export const setAccountId = (token) => {
  return sessionStorage.setItem(ACCOUNT_KEY, token)
}
export const getAccountId = () => {
  return sessionStorage.getItem(ACCOUNT_KEY)
}

// groupId
export const setUserGroupId = (userGroupId) => {
  return sessionStorage.setItem(USERGROUPID_KEY, userGroupId)
}
export const getUserGroupId = () => {
  return sessionStorage.getItem(USERGROUPID_KEY)
}

// switchAccountId
export const setSwitchAccountId = (accountId) => {
  return sessionStorage.setItem(SWITCH_ACCOUNT_KEY, accountId)
}
export const getSwitchAccountId = () => {
  return sessionStorage.getItem(SWITCH_ACCOUNT_KEY)
}
